<template>
    <div v-if="type !== 'hidden'" class="flex-row-center-jx flex-between formBar">
        <div class="flex-row-center-jx formTitle">
            <span class="text-14-black33">{{label}}</span>
            <div class="requireStart margin-left-4">
                <span v-if="required" class="color-redFE">*</span>
            </div>
        </div>

        <el-tooltip :disabled="showHover" effect="light" :content="hintText" placement="top">
            <span v-if="type === 'label'" class="contentRight"
                  :class="disable?'color-disable':'color-black33'">{{value}}</span>
            <template v-if="dataKey===true">
<!--                <div class="inputContainer contentRight">-->
<!--                    <el-autocomplete v-if="type === 'single' || type === 'number'"-->
<!--                                     :type="type==='number'?'number':'text'"-->
<!--                                     :fetch-suggestions="querySearch" @focus="onInputFocus" @blur="onInputBlur"-->
<!--                                     @select="handleSelect"-->
<!--                                     class="match-parent" @change="onValueChange(value,dataKey,key)" v-model="value"-->
<!--                                     placeholder="请输入内容" @mousewheel.native.prevent>-->
<!--                        <template slot-scope="{ item }">-->
<!--                            <div class="name">{{ item.name }}</div>-->
<!--                        </template>-->
<!--                        <template v-if="needEnd" slot="append">%</template>-->
<!--                    </el-autocomplete>-->
<!--                    <i v-if="showClearIcon" class="el-icon-circle-close inputClear" @click="clearInput"/>-->
<!--                </div>-->
                <el-autocomplete v-if="type === 'single' || type === 'number'"
                                 :type="type==='number'?'number':'text'"
                                 :fetch-suggestions="querySearch"
                                 @select="handleSelect"
                                 class="contentRight" @change="onValueChange(value,dataKey,key)" v-model="value"
                                 placeholder="请输入内容" @mousewheel.native.prevent>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                    </template>
                    <template v-if="needEnd" slot="append">%</template>
                </el-autocomplete>
            </template>

            <template v-if="dataKey==='special'">
                <el-autocomplete v-if="type === 'single' || type === 'number'"
                                 :type="type==='number'?'number':'text'"
                                 :fetch-suggestions="debtQuerySearch"
                                 @select="newHandleSelect"
                                 class="contentRight" @keyup.native="onNewValueChange(value,dataKey,key)" v-model="value"
                                 placeholder="请输入内容" @mousewheel.native.prevent>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.name }}</div>
                    </template>
                    <template v-if="needEnd" slot="append">%</template>
                </el-autocomplete>
            </template>
            <template v-if="!dataKey">
                <!--                <div class="inputContainer contentRight">-->
                <!--                    <el-input v-if="type === 'single' || type === 'number'"-->
                <!--                              :type="type==='number'?'number':'text'" @input="watchInput($event)"-->
                <!--                              @clear="clearInput" @focus="onInputFocus" @blur="onInputBlur"-->
                <!--                              class="match-parent" @change="onValueChange" v-model="value"-->
                <!--                              placeholder="请输入内容" @mousewheel.native.prevent>-->
                <!--                        <template v-if="needEnd" slot="append">%</template>-->
                <!--                    </el-input>-->
                <!--                    <div v-if="showClearIcon" class="container flex-row-center" @click="clearInput">-->
                <!--                        <i class="el-icon-circle-close inputClear" @click.stop.prevent="clearInput"/>-->
                <!--                    </div>-->
                <!--                </div>-->
                <el-input v-if="type === 'single' || type === 'number'"
                          :type="type==='number'?'number':'text'"
                          @input="watchInput($event)" @clear="clearInput"
                          class="contentRight" @change="onValueChange" v-model="value"
                          placeholder="请输入内容" @mousewheel.native.prevent>
                    <template v-if="needEnd" slot="append">%</template>
                </el-input>
            </template>

            <el-select v-if="type === 'select'" class="contentRight" v-model="value" placeholder="请选择"
                       @change="onValueChange">
                <el-option v-for="item in opinions" :key="item.label" :label="item.label" :value="item.value"/>
            </el-select>
            <el-select v-if="type === 'multi-select'" class="contentRight"  multiple v-model="value" placeholder="请选择"
                       @change="onValueChange">
                <el-option v-for="item in opinions" :disabled="item.disabled" :key="item.label" :label="item.label" :value="item.value"/>
            </el-select>
            <el-date-picker v-if="type === 'datetime'" v-model="value" type="date" placeholder="选择日期"
                            class="contentRight" @change="onValueChange" value-format="timestamp"/>

            <el-input-number v-if="type === 'count'" class="contentRight" v-model="value"
                             @change="onValueChange" :min="1" :label="label"></el-input-number>
        </el-tooltip>
    </div>
</template>

<script>

    export default {
        name: 'baseFormView',
        data() {
            return {
                label: '默认头部',
                value: '',
                type: 'select',
                opinions: [],

                required: false,
                disable: false,
                hintText: '',
                maxLength: null,
                dataKey: null,
                key: null,
                showClearIcon: false,
                to:null,
                children:[]
            }
        },
        props: {
            outData: {
                type: Object,
                default() {
                    return {};
                }
            },

        },

        watch: {
            outData: {
                handler(newValue) {

                    // 外部数据发生变化
                    this.analysisData(newValue);
                },
                immediate: true
            },

        },

        components: {},
        computed: {
            showHover() {
                return this.$verify.isEmpty(this.hintText);
            },
            needEnd() {
                return false;
                // return this.type == 'number';
            },
        },
        mounted() {

        },
        methods: {
            analysisData(newData) {
                let {label, value, required, type, opinions, hintText, regx, maxLength, dataKey, key,children} = newData;
                this.label = label;
                this.value = value;
                this.type = type;
                this.regx = regx;
                this.key = key
                this.required = required;
                this.opinions = opinions;
                this.hintText = hintText;
                this.maxLength = maxLength;
                if (dataKey) {
                    let {cacheType} = JSON.parse(dataKey)
                    this.dataKey = cacheType
                }
                if (key === 'sex') {
                    console.log("analysisData-数据更新了-newData=", newData);
                    console.log("analysisData-数据更新了-value=", value);
                }
                // 如果select没有value-进行默认选取操作
                if (type === 'select' && this.$verify.isEmpty(value)
                    && !this.$verify.isEmptyArray(opinions)) {
                    let {label, value} = this.opinions[0];
                    console.log(label, '-进行初始值设置-value=', value);
                    this.value = value;
                    // this.onValueChange(value);
                    this.onNewValueChange(value)
                }
            },
            onValueChange(inputValue, judge, key) {
                if (this.type === 'number') {
                    inputValue = parseFloat(inputValue)
                }
                this.$emit('onValueChange', inputValue);
            },
            onNewValueChange(inputValue, judge, key){

                if (this.type === 'number') {
                    inputValue = parseFloat(inputValue)
                }
                if (this.to) {
                    clearTimeout(this.to);
                }
                this.to = setTimeout( ()=> {
                 this.$emit('onValueChange', inputValue);
                }, 0);

            },
            onInputFocus() {
                this.showClearIcon = true;
            },
            onInputBlur() {
                // this.showClearIcon = false;
            },
            clearInput() {
                console.log("clearInput-触发清除操作");
                this.onValueChange("");
                this.showClearIcon = false;
            },
            watchInput(data) {
                if (!this.$verify.isEmpty(this.maxLength)) {
                    if (data.length > this.maxLength) {
                        let cutOne = data.slice(0, this.maxLength);
                        if (this.type === 'number') {
                            cutOne = Number.parseInt(cutOne);
                        }
                        this.value = cutOne;
                        console.log('修剪后的数据', data.slice(0, this.maxLength));
                    }
                }
            },
            querySearch(queryString, cb) {
                let restaurants = JSON.parse(localStorage.getItem('restaurants'))
                if (restaurants.length > 0) {
                    let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                    cb(results)
                }
            },
            debtQuerySearch(queryString, cb){
                let restaurants = JSON.parse(localStorage.getItem('makeClear'))
                if (restaurants.length > 0) {
                    let results = queryString ? restaurants.filster(this.createFilter(queryString)) : restaurants;
                    cb(results)
                }
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelect(item) {
                this.value = item.name
                this.$emit('onValueChange', item.name);
            },
            newHandleSelect(item){
                this.value = item.name
                this.$emit('onValueChange', item.name);
            }
        }

    }
</script>

<style lang="scss">
    @import "src/css/form-style";

    .formBar {
        min-height: 2.4vw;
        height: 100%;
        font-size: 13px;
        justify-content: end;

        .formTitle {
            max-width: 22%;
            min-width: 22%;
            padding-left: 8px;
            width: 22%;
        }

        .contentRight {
            margin-left: $px8;
            min-width: 72%;
            max-width: 72%;
            width: 72%;
            font-size: $px14;
        }
    }

    .color-disable {
        color: #c0c4cc;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }

    input[type="number"] {
        -moz-appearance: textfield;
    }

    .inputContainer {
        position: relative;

        .container {
            position: absolute;
            right: 0;
            top: 0;
            height: 100%;
            width: 30px;
            background-color: black;

            .inputClear {
                height: 14px;
                width: 14px;
                font-size: 14px;
                color: #999;
            }
        }
    }
   .el-select__tags-text{
            color: #606266;
    }
</style>
